












































































import * as api from "@/api";
import moment from "moment";
import Vue from "vue";
// import defaultimage from '../../assets/product_thumbnail.png';
import defaultLogo from "@/assets/product_thumbnail.png";
import AppLoading from "../../components/loading.vue";

export default Vue.extend({
    components: {
        AppLoading
    },
    data() {
        return {
            queryParams: {
                skipCount: 0,
                maxResultCount: 1000,
                name: ""
            },
            selectFields: [
                { label: "全部", value: "1" },
                { label: "进行中", value: "2" },
                { label: "已截止", value: "3" },
                { label: "未开始", value: "4" }
            ],
            selectKey: "1",
            searchFile: "",
            loading: false,
            taskList: [] as api.TasksItem[],
            listCopy: [] as api.TasksItem[]
        };
    },
    created() {
        this.getFileList();
    },

    methods: {
        getCoverSrc(item) {
            return item.logo || defaultLogo;
        },
        // 获取作业列表
        async getFileList() {
            // let res;
            this.loading = true;
            let params;
            if (this.queryParams.name === "") {
                params = {
                    skipCount: this.queryParams.skipCount,
                    maxResultCount: this.queryParams.maxResultCount
                };
            } else {
                params = {
                    skipCount: this.queryParams.skipCount,
                    maxResultCount: this.queryParams.maxResultCount,
                    name: this.queryParams.name
                };
            }
            const res = await api.tasks_pageList({ ...params });
            if (!api.error(res)) {
                res.data.items.forEach(x => {
                    // x.status = ;
                    x.beginTime = moment(x.beginTime).format("YYYY-MM-DD");
                    x.endTime = moment(x.endTime).format("YYYY-MM-DD");
                    if (x.logo == null) {
                        // eslint-disable-next-line @typescript-eslint/no-var-requires
                        const defaultImage = require("../../assets/product_thumbnail.png");
                        x.logo = defaultImage;
                    } else {
                        x.logo = `${x.logo}`;
                    }
                    if (
                        moment(new Date()).isAfter(moment(x.endTime).format("yyyy-MM-DD 23:59:59"))
                    ) {
                        x.status = 3; // 已结束
                    }
                    if (
                        moment(new Date()).isAfter(
                            moment(x.beginTime).format("yyyy-MM-DD 00:00:00")
                        ) &&
                        moment(new Date()).isBefore(moment(x.endTime).format("yyyy-MM-DD 23:59:59"))
                    ) {
                        x.status = 2; // 进行中
                    }
                    if (
                        moment(new Date()).isBefore(
                            moment(x.beginTime).format("yyyy-MM-DD 00:00:00")
                        )
                    ) {
                        x.status = 1; // 未开始
                    }
                    // x.isClosed = moment(new Date()).isAfter(moment(x.endTime).format('yyyy-MM-DD 23:59:59'));
                });
                this.taskList = res.data.items;
                this.listCopy = res.data.items;
                this.selectKey = "1"; // 把筛选状态重置为全部
                this.loading = false;
            }
        },
        goSeach() {
            console.log(1);

            this.queryParams.name = this.searchFile;
            this.getFileList();
        },
        selectChange() {
            switch (this.selectKey) {
                case "1":
                    this.taskList = this.listCopy;
                    break;
                case "2":
                    this.taskList = this.listCopy.filter(x => x.status === 2);
                    break;
                case "3":
                    this.taskList = this.listCopy.filter(x => x.status === 3);
                    break;
                case "4":
                    this.taskList = this.listCopy.filter(x => x.status === 1);
                    break;
                default:
            }
        },
        // 跳转
        jump(e: any) {
            console.log(e);
            console.log(e.status);
            if (e.status === 1) {
                this.$message.warning("该作业尚未开始");
            }
            if (e.status === 2) {
                this.$router.push({
                    name: "TaskFile",
                    query: {
                        taskId: e.id,
                        taskName: e.name
                    }
                });
            }
            if (e.status === 3) {
                this.$router.push({
                    name: "TaskFile",
                    query: {
                        taskId: e.id,
                        taskName: e.name,
                        expired: "1"
                    }
                });
            }
        }
    }
});
